"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawFeeAmountFormula = void 0;
exports.getDrawFeeAmount = getDrawFeeAmount;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of DrawFee formala implementation names
 */
var DrawFeeAmountFormula;
(function (DrawFeeAmountFormula) {
    DrawFeeAmountFormula[DrawFeeAmountFormula["DEFAULT"] = 0] = "DEFAULT";
})(DrawFeeAmountFormula || (exports.DrawFeeAmountFormula = DrawFeeAmountFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getDrawFeeAmount(formula) {
    switch (formula) {
        default:
            return default_drawFeeAmount;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_drawFeeAmount = (drawAmount, drawFeePercent) => {
    // ensure valid argument types
    if (typeof drawAmount === 'number' && typeof drawFeePercent === 'number') {
        return (0, general_formulas_1.toFixedNumber)(drawAmount * (drawFeePercent / 100), 2);
    }
    return NaN;
};
//# sourceMappingURL=draw-fee-formula.js.map